<script setup lang="ts">
import bootLoaderStaticUrl from '../assets/orphex-boot-loader-static.png'
import bootLoaderUrl from '../assets/orphex-boot-loader.gif'

import { useI18n } from '@/shared/i18n'

const { t } = useI18n()
</script>

<template>
  <main
    class="app-splash fixed inset-0 z-boot flex items-center justify-center bg-[color:var(--ui-overlay-boot-backdrop)]"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-labelledby="app-splash-status"
  >
    <picture
      class="app-splash__brand block h-40 w-40 overflow-hidden rounded-full"
      aria-hidden="true"
    >
      <source media="(prefers-reduced-motion: reduce)" :srcset="bootLoaderStaticUrl" />
      <img
        class="app-splash__image block h-40 w-40 object-contain"
        :src="bootLoaderUrl"
        alt=""
        width="160"
        height="160"
        decoding="async"
      />
    </picture>
    <span id="app-splash-status" class="app-splash__status sr-only">{{
      t('shell.boot.loading')
    }}</span>
  </main>
</template>
